import '@/modules/card';
import Swiper from 'swiper';
import SwiperCore, { Navigation } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Navigation]);

export default class CartCrossSellCarousel {
    /**
        * Class constructor *
        * @arg {object} - `rootEl` check for the carousel element.
    **/
    constructor (rootEl) {
        this.rootEl = rootEl;
        if (!rootEl) return;

        this.sliderElement = this.rootEl.querySelector('.js-cross-sell-swiper');
        this.arrowNext = this.rootEl.querySelector('.swiper-button-next');
        this.arrowPrev = this.rootEl.querySelector('.swiper-button-prev');

        this.cart = new CrossSellAddToCart();

        this.bindEvents();
        this.init();
    }

    init() {
        if (!this.sliderElement) return;

        const swiperConfig = {
            slidesPerView: 'auto',
            spaceBetween: 16,
            threshold: 10,
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev
            },
            watchOverflow: true,
        };

        if (this.sliderElement.swiper) {
            this.sliderElement.swiper.destroy(true, true);
        }

        new Swiper(this.sliderElement, swiperConfig);
    }

    bindEvents() {
        // Update selected variant
        const variantSelectForms = this.rootEl.querySelectorAll('.js-cart-notification-cross-sell-variants-form');
        if (variantSelectForms) {
            variantSelectForms.forEach(form => {
                form.addEventListener('change', event => {
                    event.preventDefault();

                    const addToCartButton = form.closest('.js-cart-notification-cross-sell').querySelector('.js-cart-notification-cross-sell-add-cta');
                    addToCartButton.dataset.variantId = event.target.value;
                });
            });
        }

        // Add to cart
        this.rootEl.addEventListener('click', (e) => {
            const btn = e.target.closest('[data-cross-sell-add]');
            if (!btn) return;

            const variantId = btn.dataset.variantId;
            if (!variantId) return;

            this.cart.add(variantId, btn);
        });
    }
}

class CrossSellAddToCart {
    add(variantId, triggerEl) {
        if (!variantId) return;

        const items = [{ id: Number(variantId), quantity: 1 }];

        const root = triggerEl.closest('[data-cross-sell-context]');
        const context = root?.dataset.crossSellContext;

        if (context === 'mainCart') {
            return this.addToCartPage(items);
        }

        return this.addToMiniCart(items);
    }

    addToMiniCart(items) {
        const cart = document.querySelector('cart-notification');
        if (!cart?.addToCart) {
            console.warn('CartNotification not ready');
            return;
        }
        cart.addToCart(items);
    }

    addToCartPage(items) {
        const sections = this.getCartPageSectionsToRender();

        return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
                items,
                sections: sections.map((s) => s.section),
                sections_url: window.location.pathname
            })
        })
            .then((r) => r.json())
            .then((state) => {
                if (state.status) return;
                this.renderCartPageContents(state, sections);
            })
            .catch(console.error);
    }

    getCartPageSectionsToRender() {
        return [
            {
                id: 'main-cart-items',
                section: document.getElementById('main-cart-items')?.dataset?.id,
                selector: '.js-contents'
            },
            {
                id: 'main-cart-items',
                section: document.getElementById('main-cart-items')?.dataset?.id,
                selector: '.js-related-cross-sell-context'
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section'
            },
            {
                id: 'cart-live-region-text',
                section: 'cart-live-region-text',
                selector: '.shopify-section'
            },
            {
                id: 'main-cart-footer',
                section: document.getElementById('main-cart-footer')?.dataset?.id,
                selector: '.js-contents'
            },
            {
                id: 'main-cart-footer',
                section: document.getElementById('main-cart-footer')?.dataset?.id,
                selector: '.js-evergreen-cross-sell-context'
            }
        ].filter(s => s.section);
    }

    renderCartPageContents(state, sections) {
        sections.forEach((section) => {
            const container = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            const html = state.sections?.[section.section];
            if (!container || !html) return;

            const doc = new DOMParser().parseFromString(html, 'text/html');
            const inner = doc.querySelector(section.selector);
            if (!inner) return;

            container.innerHTML = inner.innerHTML;
        });

        this.postRenderCartPageContents();
    }

    postRenderCartPageContents() {
        const carousels = document.querySelectorAll('.js-cart-cross-sell-carousel');
        if (!carousels.length) return;

        carousels.forEach(el => new CartCrossSellCarousel(el));
    }
}
